import FetchData from '@shared/utils/fetchData/fetchData';

export const removeProductFromComparison = async (products?: string[]) => {
  return await FetchData.delete<{ message: string }>('comparison', {
    body: products ? JSON.stringify({ products }) : undefined
  });
};
